import styled from 'styled-components';

export const MapWrapper = styled.div`
  height: 100%;

  *:focus {
    outline: none;
  }
`;
